import axios from "../../axios";

const getBillById = async (bill_id) => {
  try {
    const { data } = await axios.get(`/bills/${bill_id}`);
    return data;
  } catch (e) {
    throw e;
  }
}

const getAppliedPayments = async (bill_id) => {
  try {
    const { data } = await axios.get(`/bills/applied_payments/${bill_id}`);
    return data;
  } catch (e) {
    throw e;
  }
};

const getBillsByVendor = async (vendor_id, status, bill_id) => {
  console.log(vendor_id, status, bill_id, "getBillsByVendor");
  status = status === "open" ? `?paid_status[$ne]=paid` : '';
  let query = status ? "&" : '?';
  bill_id = bill_id ? `${query}bill_id[$ne]=${bill_id}` : ''; // exclude current invoice
  try {
    const { data } = await axios.get(`/bills/vendor/${vendor_id}${status}${bill_id}`);
    return data;
  } catch (e) {
    return null;
  }
};

const getBillByInventoryId = async (inventory_id) => {
  try {
    const { data } = await axios.get(`/bills/by_inventory/${inventory_id}`);
    return data;
  } catch (e) {
    return null;
  }
};

const deleteBill = async (bill_id) => {
  try {
    const { data } = await axios.delete(`/bills/${bill_id}`);
    return data;
  } catch (e) {
    throw e;
  }
};

const getBillStats = async () => {
  try {
    const { data } = await axios.get(`/bills/stats`);
    return data;
  } catch (e) {
    throw e;
  }
};

export { getBillsByVendor, getAppliedPayments, deleteBill, getBillById, getBillStats, getBillByInventoryId };